const calcArrowAngle = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number => {
  let angle = 0;
  const x = x2 - x1;
  const y = y2 - y1;

  if (x === 0) {
    // eslint-disable-next-line unicorn/prefer-minimal-ternary -- keep the explicit angle branches; this value feeds arrow-head rendering geometry
    angle = y === 0 ? 0 : y > 0 ? Math.PI / 2 : (Math.PI * 3) / 2;
  } else if (y === 0) {
    angle = x > 0 ? 0 : Math.PI;
  } else {
    angle =
      x < 0
        ? Math.atan(y / x) + Math.PI
        : y < 0
          ? Math.atan(y / x) + 2 * Math.PI
          : Math.atan(y / x);
  }

  return (angle * 180) / Math.PI + 90;
};

export default calcArrowAngle;
